<template>
  <div>
    <v-card class="box-container ma-0 pa-2" align="center" justify="center">
      <v-card-actions class="row-header ma-0 pa-4">
        <v-col class="ma-0 pa-0">
          <v-row class="ma-0 pa-0" align="center" justify="center">
            <span class="title">{{ title }}</span>
          </v-row>
          <v-divider></v-divider>
        </v-col>
      </v-card-actions>
      <v-card-actions class="row-content">
        <v-col class="ma-0 pa-0">
          <v-row v-for="(line, idx) in text.split('\n')" :key="idx" class="ma-0 pa-0 mx-1" align="center" justify="start">
            <span style="text-align: justify; white-space: pre-wrap; word-wrap: break-word" class="subtitle">{{ line }}</span>
          </v-row>
        </v-col>
      </v-card-actions>
      <v-card-actions class="row-header ma-0 pa-0">
        <v-row class="ma-2 pa-0" align="center" justify="center">
          <v-col cols="3" class="ma-0 pa-0" justify="start">
            <v-card v-if="buttonCancelText" align="center" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="'info'" class="ma-0 pa-2 no-text-transform white--text" @click="resolve(null)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonCancelText }}</span>
            </v-card>
          </v-col>
          <v-col cols="1" class="ma-0 pa-0"> </v-col>
          <v-col cols="3" class="ma-0 pa-0" justify="start">
            <v-card v-if="buttonYesText" align="center" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="'info'" class="ma-0 pa-2 no-text-transform white--text" @click="resolve(true)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonYesText }}</span>
            </v-card>
          </v-col>
          <v-col cols="1" class="ma-0 pa-0"> </v-col>
          <v-col cols="3" class="ma-0 pa-0" justify="start">
            <v-card v-if="buttonNoText" align="center" :width="200" style="display: flex; cursor: pointer; height: 100%" :color="'info'" class="ma-0 pa-2 no-text-transform white--text" @click="resolve(false)">
              <span style="white-space: normal; word-wrap: break-word; margin: auto auto">{{ buttonNoText }}</span>
            </v-card>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      title: "",
      text: "",
      buttonYesText: "",
      buttonNoText: "",
      buttonCancelText: "",
    };
  },
  computed: {
    getData() {
      return this.data.filter((d) => d.toString().toLowerCase().contains(this.searchText.toLowerCase()));
    },
  },
  methods: {
    resolve(result) {
      this.dialog.result = result;
      this.dialog.close();
    },
  },
  created() {
    this.data = this.dialog.data;
    if (this.dialog.options) {
      this.title = this.dialog.options.title;
      this.text = this.dialog.options.text;
      this.buttonYesText = this.dialog.options.buttonYesText;
      this.buttonNoText = this.dialog.options.buttonNoText;
      this.buttonCancelText = this.dialog.options.buttonCancelText;
    }
  },
  mounted() {},
};
</script>
